export default [{
    name: 'practice',
    path: '/practice',
    component: () => import('@/views/practice')
},
{
    path: '/practice/add',
    component: () => import('@/views/practice/add')
},
{
    path: '/practice/:id',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/practice/detail')
},
{
    path: '/practice/:id/edit',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/practice/edit')
},
]